export enum TableSortingDirection {
  Asc = "asc",
  Desc = "desc",
}
